import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../../app/store";

export interface AppState {
  notifs: { messages?: number };
}

const initialState: AppState = { notifs: { messages: 0 } };

export const appSlice = createSlice({
  name: "app",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setNotifMessages: (state, action: PayloadAction<number>) => {
      state.notifs.messages = action.payload;
    },
    addNotifMessage: (state) => {
      const oldMess = state.notifs.messages ?? 0;
      state.notifs.messages = oldMess + 1;
    },
    // removeNotifMessage: (state) => {
    //   const oldMess = state.messages ?? 0;
    //   state.messages = oldMess - 1;
    // },
    // resetNotifMessages: (state) => {
    //   state.messages = undefined;
    // },
  },
});

export const { setNotifMessages, addNotifMessage } = appSlice.actions;

export const selectNotifMessages = (state: RootState) =>
  state.app.notifs.messages;

export default appSlice.reducer;
